// extracted by mini-css-extract-plugin
module.exports = {"ViewMore":"ViewMore_ViewMore__FTmd8","Links":"ViewMore_Links__15HeZ","Icon":"ViewMore_Icon__zRxoT","More":"ViewMore_More__1B9Lq","Less":"ViewMore_Less__1AevA"};